import { types as t, Instance } from 'mobx-state-tree';
import Sensor from '~/mst/models/device/sensor';
import BitConfigType from '~/mst/common/bit_config_type';

const DustTrakSensor = t.compose(
  t.model({
    photometric_calibration: t.maybe(t.frozen()),
    auto_zero: t.maybe(t.frozen()),
    auto_zero_enabled: t.maybe(BitConfigType),
    auto_zero_time: t.maybe(t.frozen()),
    flow_calibration: t.maybe(t.frozen()),
    pm_microgram: t.maybe(BitConfigType),
    pm1_stel_alert: t.maybe(t.frozen()),
    pm25_stel_alert: t.maybe(t.frozen()),
    pm4_stel_alert: t.maybe(t.frozen()),
    pm10_stel_alert: t.maybe(t.frozen()),
    total_stel_alert: t.maybe(t.frozen()),
    size_correction: t.maybe(t.frozen()),
    profile: t.maybe(t.frozen())
  }),
  Sensor
);

export interface IDustTrakSensor extends Instance<typeof DustTrakSensor> {}

export default DustTrakSensor;
